export interface TaxRegimeOption {
  label: string;
  value: string;
}

const RE_EXPERT_TOP_TAX_REGIMES = ['VAT_22_ONLY', 'VAT_22_RA_4_CASSA_EXEMPT'];

/**
 * Regimi fiscali più frequenti per tipologia di fiduciario (almeno 4 ricorrenze),
 * mostrati in cima nell'ordine indicato. Le altre voci seguono in ordine alfabetico.
 */
export const TOP_TAX_REGIMES_BY_PROFESSIONAL_TYPE: Readonly<Record<string, readonly string[]>> = {
  AUTO_EXPERT: ['VAT_22_ONLY', 'VAT_22_RA_4_INPS_NOT_EXEMPT', 'VAT_22_RA_5_CASSA_EXEMPT'],
  RE_EXPERT: RE_EXPERT_TOP_TAX_REGIMES,
  EXPERT_RE: RE_EXPERT_TOP_TAX_REGIMES,
  INVESTIGATOR: ['VAT_22_ONLY', 'FLAT', 'VAT_22_RA_4_INPS_NOT_EXEMPT'],
  DOCTOR: ['VAT_22_RA', 'VAT_22_ONLY'],
  LAWYER: ['VAT_22_RA_4_CASSA_EXEMPT', 'FLAT_4_CASSA', 'RA_4_CASSA_EXEMPT'],
  BODYSHOP: ['VAT_22_ONLY'],
  HAIL_PROVIDER: ['VAT_22_ONLY'],
};

export function sortTaxRegimeOptions<T extends TaxRegimeOption>(
  options: readonly T[],
  professionalType: string | null | undefined,
): T[] {
  const topKeys = TOP_TAX_REGIMES_BY_PROFESSIONAL_TYPE[(professionalType || '').toUpperCase()] ?? [];
  const top = topKeys
    .map((key) => options.find((option) => option.value === key))
    .filter((option): option is T => !!option);
  const rest = options
    .filter((option) => !topKeys.includes(option.value))
    .sort((a, b) => a.label.localeCompare(b.label, 'it', { sensitivity: 'base' }));
  return [...top, ...rest];
}
